import Immutable from 'seamless-immutable';
import { GisType } from '../actions/GisAction';
import { point } from '@turf/turf';

const initialState = Immutable({
  loading: false,
  surveyedDetailData: null,
  showSideContent: true,
  surveyedMapType: 'point',
  mapLoaded: false,
  isPredicted: true,
  isActual: true,
  pointPopup: [0, 0],
  showTopContent: true,
  showBottomContent: true,
  tableData: {},
  pointRowData: {},
  lineRowData: {}
});

const GisReducer = (state = initialState, action) => {
  switch (action.type) {
    case GisType.LOADING:
      return state.merge({
        loading: true
      })
    case GisType.ERROR:
      return state.merge({
        loading: false,
      })
    case GisType.GET_SURVEYEDDETAIL_SUCCESS:
      return state.merge({
        surveyedDetailData: action.data,
        loading: false,
      })
    case GisType.TOGGLE_SHOW_SIDE_CONTENT:
      return state.merge({
        showSideContent: !state.showSideContent,
        loading: false,
      })
    case GisType.SET_SURVEYED_MAP_TYPE:
      return state.merge({
        surveyedMapType: action.value,
      })
    case GisType.MAP_LOADED:
      return state.merge({
        mapLoaded: action.value,
      });
    case GisType.PREDICTED:
      return state.merge({
        isPredicted: action.value
      });
    case GisType.ACTUAL:
      return state.merge({
        isActual: action.value
      });
    case GisType.POINT_POPUP:
      return state.merge({
        pointPopup: action.value
      });
    case GisType.RESET_DATATYPE:
      return state.merge({
        isActual: true,
        isPredicted: true
      });
    case GisType.TOGGLE_SHOW_TOP_CONTENT:
      return state.merge({
        showTopContent: !state.showTopContent,
        loading: false,
      });
    case GisType.TOGGLE_SHOW_BOTTOM_CONTENT:
      return state.merge({
        showBottomContent: !state.showBottomContent,
        loading: false,
      });
    case GisType.SET_TABLE_DATA:
    return state.merge({
      tableData: action.data
    });
    case GisType.SELECT_POINT_ROW:
    return state.merge({
      pointRowData: action.data
    });
    case GisType.SELECT_LINE_ROW:
    return state.merge({
      lineRowData: action.data
    });
    default:
      return state
  }
}

export default GisReducer
